import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { DataContext } from "../../context/DataContext";

const NoData = () => {
  const { selection, countyData } = useContext(DataContext);
  if (selection) {
    const { county } = selection;
    const selectedCounty = countyData.find(
      (countyDatum) => countyDatum.id === county
    );
    const { note } = selectedCounty;
    return (
      <div className="no-data__container">
        <h3 className="no-data__title">
          <FontAwesomeIcon
            className="panel__icon-exclamation-circle"
            size="3x"
            icon={faExclamationCircle}
          />{" "}
        </h3>
        <p className="no-data__note">{note}</p>
      </div>
    );
  }
  return null;
};

export default NoData;
